<template>
  <div>
    <div class="detail-search">
      <input type="text" v-model="data.dispWords" v-bind:disabled="true" />
      <button @click="clickButton" v-tooltip="'詳細検索'">
        <img src="/assets/icon-settings.svg" alt="詳細検索">
      </button>
    </div>
    <div class="action-overlay" v-show="data.showFlg">
      <div class="container">
        <p>投稿日</p>
        <div class="item">
          <input type="date" placeholder="" v-model="data.entryAt"><span class="focusborder"></span>
        </div> 
        <div class="item" v-show="entryDivisionId != entryDivisionIdCircle">
          <p>サークル</p>
          <mentionable
            :keys="['%']"
            :items="data.circleItems"
            :limit="data.mentionLimit"
            insert-space>
            <textarea v-model="data.circleNames" class="flextextarea-textarea" id="flextextarea" placeholder="%を入力してください" ref="area" :style="styles"></textarea>
            <template #no-result>
              <div class="dim">
                No result
              </div>
            </template>
            <template #item-%="{ item }">
              <div class="issue">
                {{ item.name }}
              </div>
            </template>
          </mentionable>
        </div> 
        <div class="item">
          <p>話題</p>
          <mentionable
            :keys="['#']"
            :items="data.hashtagItems"
            :limit="data.mentionLimit"
            insert-space>
            <textarea v-model="data.hashtagNames" class="flextextarea-textarea" id="flextextarea" placeholder="#を入力してください" ref="area" :style="styles"></textarea>
            <template #no-result>
              <div class="dim">
                No result
              </div>
            </template>
            <template #item-#="{ item }">
              <div class="issue">
                {{ item.name }}
              </div>
            </template>
          </mentionable>
        </div> 
        <div class="item">
          <p>フリーワード</p>
          <input type="text" placeholder="入力する" v-model="data.freeWords"><span class="focusborder"></span>
        </div>
        <div class="action">
          <button class="clear" @click="reset">フィルタ条件をクリア</button>
          <button class="cancel" @click="clickButton">戻る</button>
          <button class="confirm" @click="doFilter">フィルタ実行</button>
        </div>
      </div>
    </div>
  </div>  
</template>
<script setup>
import axios from 'axios'
import Global from '../../js/constant.js'
// import mention from '@/js/components/mention.js'
import mentionUtils from '../../js/mention-utils.js'
import { computed, defineProps, onMounted, reactive, watch } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';

const $store = useStore()
const $toast = useToast()

// props
const props = defineProps({
  entryDivisionId : {
    type : Number,
    required : true
  },
  circleId : {
    type : Number,
    required : false
  }
})
// const {mentionStates, getDestinations, getHashtags} = mention()
// states
const data = reactive({
  showFlg:false,
  dispWords: null,
  circleNames: null,
  entryAt: null,
  freeWords: null,      
  hashtagNames: null,
  height: "90px",
  circles: [],
  hashtags: [],
  circleItems: [],
  hashtagItems: [],
  mentionLimit: Global.vue_mention_limit,
})

// mapstates
const account = computed(() => $store.state.core.account)
const circleHashtagDivisionId = computed(() => $store.state.circle.circleHashtagDivisionId)
// const filterItems = computed(() => $store.state.entryFilter.items)
const hashtagDivisionId = computed(() => $store.state.square.hashtagDivisionId)

// mapmutations
// const initItems = (val) => $store.commit('initItems', val)
const setItems = (val) => $store.commit('setItems', val)
const setClientErrors = (val) => $store.commit('setClientErrors', val)


// computed
const styles = computed(() => {
  return {
    "height": data.height,
  }
})
const entryDivisionIdCircle = computed(() => Global.entry_division_id.circle)

// watch
watch(() => data.circleNames, (circleNames) => {
  if (circleNames == null) {
    init()
    return
  }
  data.hashtagItems = []
  // eslint-disable-next-line
  let _circleNames = circleNames.replace(/%/g, "").replace(/　/g," ").split(' ').filter(row => row)
      
  if (_circleNames.length == 0) {
    init()
  } else {
    let _circles = data.circles.filter(circle => [..._circleNames].includes(circle.circle_name))

    _circles.forEach(circle => {
      let isMember = false
      if (account.value != null) {
        isMember = circle.members.filter(mem => mem.id == account.value.id).length > 0
      }
      let hashtagItems = circle.hashtags.filter(hashtag => {
        if (!isMember) {
          return hashtag.official_circle == true
        } else {
          return true
        }            
      })
      .map(hashtag => mentionUtils.getMentionHashtagStates(props.entryDivisionId, hashtag)) 
      data.hashtagItems = [...hashtagItems]
    });
  }
})

onMounted(async () => {
  data.circles = await getCircles()

  if (props.circleId != null) {
    data.circles = data.circles.filter(circle => circle.id == props.circleId)
  }
  init()
})


// methods
const init = async () => {
  // サークル（複数）情報取得
  data.circleItems = data.circles.map(row => mentionUtils.getMentionCircleStates(row))
  
  // サークルが保持するハッシュタグを取得
  data.circles.forEach(circle => {
    let isMember = false
    if (account.value != null) {
      isMember = circle.members.filter(mem => mem.id == account.value.id).length > 0
    }

    let hashtagItems = circle.hashtags.filter(hashtag => {
      if (!isMember) {
        return hashtag.official_circle == true
      } else {
        return true
      }
    })
    .filter(hashtag => ![...data.hashtagItems.map(hashtag => hashtag.name)].includes(hashtag.name))
    .map(hashtag => mentionUtils.getMentionHashtagStates(props.entryDivisionId, hashtag))
    data.hashtagItems.push(...hashtagItems)
  });

  // propsサークルがない場合は広場のハッシュタグもメンションにする
  if (props.circleId == null) {
    data.hashtags = await getHashtags()
    data.hashtagItems.push(...data.hashtags.map(row => mentionUtils.getMentionHashtagStates(props.entryDivisionId, row)))
    // if (props.entryDivisionId === Global.entry_division_id.square) setSqureHashtags(data.hashtags)
  }
}
const clickButton = () => {
  data.showFlg = !data.showFlg
}
const doFilter = () => {
  let _circleNames = null
  let _circleIds = null
  let _hashtagNames = null
  let _hashtagIds = null
  let _freeWords = null
  if (data.circleNames) {
    // eslint-disable-next-line
    _circleNames = data.circleNames.replace(/　/g," ").split(' ').filter(row => row)
            
    _circleIds = data.circles.filter(c => {
      return _circleNames.filter(n => n.replace(/%/g, "") == c.circle_name).length > 0
    }).map(c => c.id)
  }
  if (data.hashtagNames) {
    // eslint-disable-next-line
    _hashtagNames = data.hashtagNames.replace(/　/g," ").split(' ').filter(row => row)
    _hashtagIds = data.hashtagItems.filter(r => _hashtagNames.filter(h => h.replace(/#/g, "") == r.value).length > 0).map(h => h.id)
  }
  if (data.freeWords) {
    // eslint-disable-next-line
    _freeWords = data.freeWords.replace(/　/g," ").split(' ')
  }
  setItems({
    entryAt: data.entryAt,
    circleNames: _circleNames,
    circleIds: _circleIds,
    hashtagNames: _hashtagNames,
    hashtagIds: _hashtagIds,
    freeWords: _freeWords,
  })
  data.dispWords = ''
  if (data.entryAt) data.dispWords = `${data.dispWords}  ${data.entryAt}`
  if (_circleNames) data.dispWords = `${data.dispWords}  ${data.circleNames}`
  if (_hashtagNames)  data.dispWords = `${data.dispWords}  ${data.hashtagNames}`
  if (_freeWords) data.dispWords = `${data.dispWords}  ${data.freeWords}`
  data.showFlg = !data.showFlg
}
const reset = () => {
  data.entryAt = null
  data.circleNames = null
  data.hashtagNames = null
  data.freeWords = null

  setItems({
    entryAt: null,
    circleNames: null,
    circleIds: null,
    hashtagNames: null,
    hashtagIds: null,
    freeWords: null,
  })
  data.dispWords = ''
}
const getCircles = async () => {
  let params = {}
  if (account.value != null) params['account_id'] = account.value.id
  return await axios.post( Global.url.api_all_circles, params).then(res => {
    if (res.data.status == Global.api_status.success) {
      return res.data.circles
    }
    return []
  }).catch(error=>{
    $toast.error('client error')
    setClientErrors({func:"common/entry/filter.vue::getCircles", params: {account_id : account.value && account.value.id}, errorMessage:error})
  })
}
const getHashtags = async () => {
  let url = mentionUtils.getHashtagsUrl(props.entryDivisionId)
  let _hashtagDivisionId = props.circleId ? circleHashtagDivisionId.value : hashtagDivisionId.value
  let params = mentionUtils.getHashtagsParameters(props.entryDivisionId, _hashtagDivisionId, account.value && account.value.id, props.circleId)
  return await axios.post(url, params).then(res => {
    if (res.data.status === Global.api_status.success) {
      return res.data.hashtags
    }
    return []
  })
  .catch(error=>{
    $toast.error('client error')
    setClientErrors({func:"common/entry/filter.vue::getHashtags", params: params, errorMessage:error})
  })
}

</script>